export const enum spaceSlugType {
  BRAND_BLOCK = 'BrandBlock',
  LISTING_BANNER = 'ListingBanner',
  PROMO_BLOCK = 'PromoBlock',
  RECTANGULAR_BLOCK = 'RectangularBlock',
}
